import React, { Component } from 'react';

class InfoSuperior extends Component {
    constructor(props) {
        super(props);
        this.state = {  };
    }
    render() {
        let logo="";
        let inconoTipo="";
        let leyendaTipo="";
        let backColor="";
        let horaFin = "-";
        const {datosEncabezado}=this.props;

        if(datosEncabezado.HoraFin){
            horaFin = (datosEncabezado.sumarDia > 0 ? (datosEncabezado.HoraFin + " +" + datosEncabezado.sumarDia + "D" ) : datosEncabezado.HoraFin)
        }


        switch(datosEncabezado.AdministradoraId){
            case 1:
                logo = " image-visa-logo procesoLogo tdSolicitudes"
            break;
    
            case 2:
                logo = " image-cabal-logo procesoLogo tdSolicitudes"
            break;
    
            case 3:
                logo = " image-mastercard-logo procesoLogo tdSolicitudes"
            break;
        }

        switch (datosEncabezado.TipoProceso){
            case "P" :
                inconoTipo= 'icono-gear2'
                leyendaTipo= 'Proceso'
            break;
            
            case "I" :
                inconoTipo= 'icono-input2'
                leyendaTipo= 'Archivo Input'
            break;
            
            case "O" :
                inconoTipo= 'icono-output2'
                leyendaTipo= 'Archivo Output'
            break;
        }

        switch (datosEncabezado.ColorResultado){
            case "VERDE" :
                backColor= ' procesosVerde'
            break;
            
            case "ROJO" :
                backColor= ' procesosRojo'
            break;
            
            case "AZUL" :
                backColor= ' procesosAzul'
            break;
            
            case "AMARILLO" :
                backColor= ' procesosAmarillo'
            break;
        }

        return (
            <div className={"contenedorDatosProceso "}>
                <div className="flexCellCenter bottom-separator-xxs">
                    <div className={logo}></div>
                    <div className='tituloCentralProcesosFill'>Detalle de errores y notas</div>
                </div>
                <div className={"etiquetaTituloErroresProcesos procesoColumnRight " + backColor}>
                    <div className="procesoColumnLeft alignItemsCenter">
                        <div className={inconoTipo + " left-separator-xxs"}></div>
                        <div className='left-separator-xxs'>
                            <div className='tituloProcesosBarraSuperior'>{datosEncabezado.DescripcionProceso}</div>
                            <div className='tipoProcesoSmallLabel'>{leyendaTipo}</div>
                        </div>
                    </div>
                    <div className='procesoColumnLeft'>
                        <div className='tituloProcesosBarraSuperiorTabIzq '>
                            <div className='tituloProcesosBarraSuperior'>{datosEncabezado.DescripcionProcesoEstado}</div>
                            <div className='tipoProcesoSmallLabel'>{datosEncabezado.CantidadRegistrosOriginal + " registros totales"}</div>
                        </div>
                        <div className='flexColumn left-separator-xs'>
                            <div className='tipoProcesoSmallLabel'>{/*this.props.roceso.horaInicio*/"Inicio " + datosEncabezado.HoraInicio}</div>
                            <div className='tipoProcesoSmallLabel'>{/*this.props.roceso.horaFin*/"Fin " + horaFin }</div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default InfoSuperior;